import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import StagingOrReturnModal from "./StagingOrReturnModal";
import useAuth from "src/hooks/useAuth";
import ScanOrEnterModal from "src/views/inventory/requests/orders/ScanOrEnterModal";
import ScanOutModal from "src/views/inventory/requests/orders/ScanOutModal";
import { getDisplayRackLocations } from "src/utils/internalWorkOrderRackLocations";
import { formatRackLocationLabel } from "src/utils/rackLocations";

export default function PickingAndStaging({ asset, internalWorkOrderItem, internalWorkOrder }) {
  const { user } = useAuth();
  const { settings } = user.company;
  const [openModal, setOpenModal] = useState(false);
  const [openScanOrEnterModal, setOpenScanOrEnterModal] = useState(false);
  const [openScanModal, setOpenScanModal] = useState(false);
  const rackLocations = getDisplayRackLocations({ item: internalWorkOrderItem, asset });
  const formattedPickLocations = rackLocations.map(rl => formatRackLocationLabel(rl, { includeQty: true })).join("\n");

  const handleClick = () => {
    if (settings?.scan_out_modal) {
      setOpenScanOrEnterModal(true);
    } else {
      setOpenModal(true);
    }
  };

  return (
    <>
      <Card>
        <CardContent>
          <Box mb={1}>
            <Typography fontWeight={500} fontSize={18}>
              Pull From
            </Typography>
          </Box>
          <Box mb={2}>
            <TextField
              fullWidth
              multiline
              disabled
              size="small"
              variant="outlined"
              label="Picking From"
              value={formattedPickLocations}
              InputProps={{
                readOnly: true,
              }}
            />
          </Box>
          {internalWorkOrderItem.pickedStatus ? (
            <Button fullWidth variant="outlined" color="primary" disabled>
              Staging Complete
            </Button>
          ) : (
            <Button fullWidth variant="outlined" color="primary" onClick={handleClick}>
              Scan to Staging Area
            </Button>
          )}
        </CardContent>
      </Card>

      {openModal && (
        <StagingOrReturnModal
          open={openModal}
          mode="staging"
          asset={asset}
          item={internalWorkOrderItem}
          internalWorkOrder={internalWorkOrder}
          onClose={() => setOpenModal(false)}
        />
      )}

      {openScanOrEnterModal && (
        <ScanOrEnterModal
          asset={asset}
          onClose={() => setOpenScanOrEnterModal(false)}
          openScanModal={() => setOpenScanModal(true)}
          markAsPicked={async () => {
            setOpenScanOrEnterModal(false);
            setOpenModal(true);
          }}
          enableSuccessNotification={false}
        />
      )}

      {openScanModal && (
        <ScanOutModal
          asset={asset}
          onClose={() => setOpenScanModal(false)}
          onScanComplete={async () => {
            setOpenScanModal(false);
            setOpenModal(true);
          }}
        />
      )}
    </>
  );
}
